<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :style="myTheme.footer"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <n-button :style="{'color' : myTheme.footer.color}"
              type="primary"
              link
              block
              @click="goToTc('policy')"
            >{{$t('label.privacy_policy')}}</n-button>
          </li>
          <li>
            <n-button :style="{'color' : myTheme.footer.color}"
              type="primary"
              link
              block
              @click="goToTc('terms')"
            >{{ this.$t('label.terms_and_conditions') }}</n-button>
          </li>
          <li>
           <n-button :style="{'color' : myTheme.footer.color}"
              type="primary"
              link
              block
              @click="goToTc('allergy')"
            >{{ $t('label.allergy_information') }}</n-button>
          </li>
                <li class="last-child-powered" style="margin-left: 19pc">
           <a href="https://whatthefork.co.uk" >
              {{ $t('label.powered_by') }}
           </a>
      
          </li> 
        </ul>
        <div>
      </div>
      </nav>
      <div class="copyright">
        <div class="button-container">
          <a :href="business.twitter_url" target="_blank" v-if="business.twitter_url"  class="btn btn-twitter btn-round btn-small btn-icon" rel="tooltip"  :title="$t('title.follow_on_twitter')">
          <i class="fab fa-twitter"></i>
          </a>
          <a :href="business.facebook_url" target="_blank" v-if="business.facebook_url"  class="btn btn-facebook btn-round btn-small btn-icon" rel="tooltip"  :title="$t('title.follow_on_facebook')">
          <i class="fab fa-facebook"></i>
          </a>
          <a :href="business.instagram_url" target="_blank" v-if="business.instagram_url"  class="btn btn-instagram btn-round btn-small btn-icon" rel="tooltip"  :title="$t('title.follow_on_instagram')">
          <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import router from '@/router';
import { mapState } from "vuex";
import {Button} from '@/components'
export default {
  components : {
    [Button.name] : Button,
  },
  props: {
    backgroundColor: String,
    type: String
  },
  computed: {
    ...mapState({
      business: state => state.business,
    })
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  methods:{
    goToTc(docName){
      //router.push('/termsandconditions?doc='+docName);
      router.push({ name: 'termsandconditions', params: { doc: docName } })
    }
  }
};
</script>
<style>
.powered-by{
  margin-left: auto;
  margin-right: auto;
}
 @media screen and (max-width: 1024px) {
       .last-child-powered{
         margin-left: 0px !important;
       }
      }

</style>
